import {QuickAddItemType} from "../../../quick-add/@types";

const debug = false
// const debug = "openFormAction"

export default function openFormAction(params: {
    id          : ID,
    publicKey   : string
}) {
    debug && console.log(debug, 'open',params)

    if (params.publicKey) {
        window.open(gdConfig.sharedViewPath + params.publicKey)
    } else {
        gd.openNew(QuickAddItemType.REQUEST, {id: params.id})
    }
}